import createReducer from '../utils/createReducer';
import {
  BOB_FORMS_REQUEST,
  BOB_FORMS_FAILURE,
  BOB_FORMS_SUCCESS,
} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [BOB_FORMS_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [BOB_FORMS_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: [].concat(payload.data),
      token: payload.token,
    })
  ),
  [BOB_FORMS_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/bobForms.js